import { createContext, useContext } from 'react';
import { KeycloakInstance, KeycloakProfile } from 'keycloak-js';

export interface AuthContextType {
  keycloak: KeycloakInstance | null;
  initialized: boolean;
  authenticated: boolean;
  profile: KeycloakProfile | null;
  login: () => void;
  logout: () => void;
}

export const AuthContext = createContext<AuthContextType | null>(null);

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
};
